var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"titulo":"Validação de PTU","breadcrumb":_vm.bread,"iconeSvg":_vm.ValidacaoSvg}},[_c('TabelaValidacao')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }